"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Textarea = _styledComponents.default.textarea.withConfig({
  displayName: "Textarea",
  componentId: "design-system__sc-12x0riu-0"
})(["width:100%;min-height:100px;box-sizing:border-box;border:1px solid ", ";box-shadow:8px 0 0 ", " inset;font-family:", ";line-height:", ";border-radius:", ";background:", ";font-size:", ";padding:9px ", ";color:", ";&:disabled{background:", ";}&::placeholder{color:", ";font-style:italic;}&:focus{outline:0;}"], props => props.error ? _BaseTheme.default.colors.red : 'rgb(204,204,204)', props => props.error ? _BaseTheme.default.colors.red : 'transparent', _BaseTheme.default.type.family.content, _BaseTheme.default.type.lineHeight.regular, _BaseTheme.default.radius.regular, _BaseTheme.default.colors.white, _BaseTheme.default.type.size.normal, _BaseTheme.default.distance.normal, _BaseTheme.default.colors.gray, _BaseTheme.default.colors.inputDisabledGray, _BaseTheme.default.colors.lightgray);

Textarea.propTypes = {
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  placeholder: _propTypes.default.string,
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  error: _propTypes.default.bool,
  name: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onClick: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  onKeyUp: _propTypes.default.func
};
var _default = Textarea;
exports.default = _default;